import Seo from "../components/Seo";
import PageHero from "../components/site/PageHero";
import { ContactForm } from "../components/site/Forms";
import { useReveal } from "../lib/useReveal";
import { Mail, MapPin } from "lucide-react";

export default function Contact() {
  const ref = useReveal();
  return (
    <div ref={ref}>
      <Seo
        title="Contact"
        path="/contact"
        description="Contact Mount Moriah Relief — a charitable organisation based in Northern Ireland. Email admin@mountmoriahrelief.org or send us a message."
      />
      <PageHero eyebrow="Contact" title="We would love to hear from you">
        <p>
          Questions, partnership enquiries, offers of help — send us a message and we will respond
          as soon as we can.
        </p>
      </PageHero>

      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 reveal">
            <h2 className="font-serif text-3xl font-medium text-forest tracking-tight">Reach us directly</h2>
            <ul className="mt-8 space-y-6">
              <li className="flex items-start gap-4">
                <Mail size={22} strokeWidth={1.5} className="text-gold mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <p className="text-xs tracking-wider uppercase font-semibold text-charcoal/60">Email</p>
                  <a href="mailto:admin@mountmoriahrelief.org" className="mt-1 block text-forest font-medium hover:underline" data-testid="contact-email-link">
                    admin@mountmoriahrelief.org
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <MapPin size={22} strokeWidth={1.5} className="text-gold mt-1 shrink-0" aria-hidden="true" />
                <div>
                  <p className="text-xs tracking-wider uppercase font-semibold text-charcoal/60">Based in</p>
                  <p className="mt-1 text-charcoal">Northern Ireland, United Kingdom</p>
                </div>
              </li>
            </ul>
            <div className="mt-10 bg-sandstone/50 border border-sandstone p-6">
              <h3 className="font-serif text-xl font-semibold text-forest">Your privacy</h3>
              <p className="mt-3 text-sm text-charcoal/75 leading-relaxed">
                The details you send through this form are used only to respond to your enquiry.
                They are stored securely, visible only to authorised administrators, and handled in
                line with our <a href="/privacy-policy" className="text-forest underline">privacy notice</a>.
              </p>
            </div>
          </div>
          <div className="lg:col-span-7 reveal">
            <ContactForm kind="contact" />
          </div>
        </div>
      </section>
    </div>
  );
}
